import { createRequestTypes } from 'common/websocket-redux';

export const REQUEST_REMOVE_USER_PROMO_CODE = createRequestTypes(
  'script-helpers/REMOVE_USER_PROMO_CODE',
);
